import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';
import { ICenterBase, IConnectToDonorStatus, IDonorConnect, IListItem, IMentorEducationChoice, IUser } from '@nkr/models/index';
import { AuthRole, ConnectToDonorMilestone } from '@nkr/enums/index';
import { Button, ControlLabel, DropdownButton, FormControl, FormGroup, Glyphicon, Label, MenuItem, Panel, PanelGroup, Well } from 'react-bootstrap';
import MaskedInput from 'react-maskedinput';
import { donorConnectTabs, ICounselor, ICounts, milestones } from './models';
import Log from './log';
import styled from 'styled-components';
import WorkupSurvey from './milestones/workup-survey';
import PreOpSurvey from './milestones/preop-survey';
import PostDonationSurvey from './milestones/post-donation-survey';
import PostDonation30DaysSurvey from './milestones/post-donation-30-days-survey';
import { IFindForTransferResponse } from '@nkr/store/index';
import TransferDonor from './transfer-donor';
import PreferredDonationType from './preferred-donation-type-renderer';
import { PanelBodyWrapper } from './styles';
import ConnectToDonorStatus from './connect-to-donor-status';
import { GambitType } from '@nkr/models/gambit-type';

const DropdownButtonWrapper = styled.div`
    & > .dropdown {
        width: 100%;
    }

    & > .dropdown > button {
        width: 100%;
    }

    & > .dropdown > .dropdown-menu {
        width: 100%;
    }

    & > .dropdown > ul > li > a > .row > .col-xs-5,
    & > .dropdown > ul > li > a > .row > .col-xs-7 {
        padding-left: 5px;
        padding-right: 5px;
    }
`;

interface IProps {
    list: IDonorConnect[],
    user: IUser,
    currentTab: JSX.Element | string,
    statusFilter: number,
    counts: ICounts,
    statusList: IConnectToDonorStatus[],
    userList: ICounselor[],
    centerList: ICenterBase[],
    actionList: IListItem[],
    mentorEducationChoiceList: IListItem[],
    closeLoopDonationTypes: IListItem[],
    savedDonationDetailIds: number[],
    onTabChange: (currentTab: string) => void,
    onStatusChange: (id: number, statusId: number) => void,
    onAssignedCounselorChange: (id: number, counselorId: number) => void,
    onNextFollowUpDateChange: (id: number, value: any) => void,
    onUpdateNextFollowupDate: (id: number) => void,
    onRemoveNextFollowUpDate: (id: number) => void,
    onNextMilestone: (id: number, nextMilestone: ConnectToDonorMilestone) => void,
    onSubmitWorkupSurvey: (id: number, treatment: number, convenience: number, facility: number, commendation: string, improvement: string, completedDate: string) => void,
    onSubmitPreOpSurvey: (id: number, treatment: number, convenience: number, facility: number, commendation: string, improvement: string, completedDate: string) => void,
    onSubmitPostDonationSurvey: (id: number, treatment: number, convenience: number, facility: number, commendation: string, improvement: string, completedDate: string) => void,
    onSubmitPostDonation30DaysSurvey: (id: number, surgeonCare: number, nurseCare: number, painCare: number, caretakerTreatment: number, financialBurden: number, donationCost: number, commendation: string, improvement: string, completedDate: string) => void,
    onSaveLogEntry: (id: number, dashRegistrationId: number, actionTaken: number, comments: string, isPinned: boolean) => void,
    onDeleteLogEntry: (id: number, dashRegistrationId: number) => void,
    onGetDonorConnectLogEntries: (id: number, centerId: number, recipientCenterId: number, view: boolean) => void,
    onFindForTransfer: (centerId: number, email: string, birthDate: string) => Promise<IFindForTransferResponse>,
    onRequestTransfer: (id: number, centerId: number) => void,
    onCompleteTransfer: (id: number, existingId: number) => void,
    onMentorEducationChoiceChange: (id: number, statusId: number) => void,
    onDonationDateChange: (id: number, date: string) => void,
    onDonationCenterChange: (id: number, centerId: string) => void,
    onDonationTypeChange: (id: number, type: string) => void,
    onDonationUpdateClick: (id: number) => void,
    onFilterChange: (property: string, value: any) => void,
    onFilterSubmit: (reset: boolean) => void,
    onHoldStatusReasonChange: (id: number, onHoldStatusReason: string) => void
}

interface IState {
    registrationId: number,
    showWorkupSurvey: boolean,
    showPreOpSurvey: boolean,
    showPostDonationSurvey: boolean,
    showPostDonation30DaysSurvey: boolean,
    showTransferDonor: boolean,
    mobileActiveKey: any,
    search: string
}

class MobileView extends React.Component<IProps, IState> {
    readonly state: IState = {
        registrationId: 0,
        showWorkupSurvey: false,
        showPreOpSurvey: false,
        showPostDonationSurvey: false,
        showPostDonation30DaysSurvey: false,
        showTransferDonor: false,
        mobileActiveKey: null,
        search: ''
    }

    getCurrentTab = () => {
        let counts = this.props.counts;

        switch (this.props.currentTab) {
            case donorConnectTabs.UNASSIGNED: return <>UNASSIGNED ({counts.unassigned})</>;
            case donorConnectTabs.TODO: return <>TO-DO ({counts.todo})</>;
            case donorConnectTabs.MINE: return <>ASSIGNED TO ME ({counts.assignedToMe})</>;
            case donorConnectTabs.ALL: return <>ALL ({counts.all})</>;
        }

        return '';
    }

    handleNextMilestone = (registrationId: number, connectToDonorMilestoneCanProgress: boolean, connectToDonorNextMilestone: ConnectToDonorMilestone) => {
        if (connectToDonorMilestoneCanProgress) {
            this.props.onNextMilestone(registrationId, connectToDonorNextMilestone);
        }

        switch (connectToDonorNextMilestone) {
            case ConnectToDonorMilestone.Contacted:
                break;

            case ConnectToDonorMilestone.WorkupSurvey:
                this.setState({
                    registrationId,
                    showWorkupSurvey: true
                });

                break;

            case ConnectToDonorMilestone.PreOpSurvey:
                this.setState({
                    registrationId,
                    showPreOpSurvey: true
                });

                break;

            case ConnectToDonorMilestone.PostDonation3DaysSurvey:
                this.setState({
                    registrationId,
                    showPostDonationSurvey: true
                });

                break;

            case ConnectToDonorMilestone.PostDonation30DaysSurvey:
                this.setState({
                    registrationId,
                    showPostDonation30DaysSurvey: true
                });

                break;
        }
    }

    handleWorkupSurveySubmit = (treatment: number, convenience: number, facility: number, commendation: string, improvement: string, completedDate: string) => {
        this.setState({
            showWorkupSurvey: false
        }, () => {
            this.props.onSubmitWorkupSurvey(this.state.registrationId, treatment, convenience, facility, commendation, improvement, completedDate);
        });
    }

    handlePreOpSurveySubmit = (treatment: number, convenience: number, facility: number, commendation: string, improvement: string, completedDate: string) => {
        this.setState({
            showPreOpSurvey: false
        }, () => {
            this.props.onSubmitPreOpSurvey(this.state.registrationId, treatment, convenience, facility, commendation, improvement, completedDate);
        });
    }

    handlePostDonationSurveySubmit = (treatment: number, convenience: number, facility: number, commendation: string, improvement: string, completedDate: string) => {
        this.setState({
            showPostDonationSurvey: false
        }, () => {
            this.props.onSubmitPostDonationSurvey(this.state.registrationId, treatment, convenience, facility, commendation, improvement, completedDate);
        });
    }

    handlePostDonation30DaysSurveySubmit = (surgeonCare: number, nurseCare: number, painCare: number, caretakerTreatment: number, financialBurden: number, donationCost: number, commendation: string, improvement: string, completedDate: string) => {
        this.setState({
            showPostDonation30DaysSurvey: false
        }, () => {
            this.props.onSubmitPostDonation30DaysSurvey(this.state.registrationId, surgeonCare, nurseCare, painCare, caretakerTreatment, financialBurden, donationCost, commendation, improvement, completedDate);
        });
    }

    handleSearchChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            search: e.currentTarget.value
        });
    }

    handlePanelItemSelect = async (mobileActiveKey: any) => {
        this.props.onGetDonorConnectLogEntries(mobileActiveKey, 0, 0, false);

        this.setState({
            mobileActiveKey
        });
    }

    handleShowTransferDonor = (registrationId: number) => {
        this.setState({
            registrationId,
            showTransferDonor: true
        });
    }

    handleCancelTransferDonor = () => {
        this.setState({
            showTransferDonor: false
        });
    }

    handleRequestTransfer = (centerId: number) => {
        this.setState({
            showTransferDonor: false
        }, () => {
            this.props.onRequestTransfer(this.state.registrationId, centerId);
        });
    }

    handleCompleteTransfer = (existingId: number) => {
        this.setState({
            showTransferDonor: false
        }, () => {
            this.props.onCompleteTransfer(this.state.registrationId, existingId);
        });
    }

    handleDonationDateChange = (id: number, donationDate: string) => {
        this.props.onDonationDateChange(id, donationDate);
    }

    handleDonationTypeChange = (id: number, donationTypeId: string) => {
        this.props.onDonationTypeChange(id, donationTypeId);
    }

    handleDonationUpdateClick = (id: number) => {
        this.props.onDonationUpdateClick(id);
    }

    handleFilterChange = (e: React.FormEvent<FormControl & HTMLSelectElement & HTMLInputElement>) => {
        let name = e.currentTarget.name;
        this.props.onFilterChange(name, e.currentTarget.value);
    };

    renderNextFollowupDate = (item: IDonorConnect) => {
        let status = this.props.statusList.find(s => s.id == item.connectToDonorStatusId);

        let nextFollowUpDate = moment(item.connectToDonorNextFollowUpDate, 'MM/DD/YYYY', true);

        if (status.isClosed == false && nextFollowUpDate.isBefore(moment(), 'day')) {
            return <Label bsStyle='danger' style={{ fontSize: '100%' }}>{item.connectToDonorNextFollowUpDate}</Label>
        }

        if (status.isClosed == false && nextFollowUpDate.isAfter(moment(), 'day')) {
            return <Label bsStyle='success' style={{ fontSize: '100%' }}>{item.connectToDonorNextFollowUpDate}</Label>
        }

        if (status.isClosed == false && nextFollowUpDate.isSame(moment(), 'day')) {
            return <Label bsStyle='warning' style={{ fontSize: '100%' }}>{item.connectToDonorNextFollowUpDate}</Label>
        }

        if (status.isClosed) {
            return <Label style={{ fontSize: '100%' }}>{item.connectToDonorNextFollowUpDate}</Label>
        }

        return null;
    }

    render = () => {
        const { list, counts, statusList, userList, actionList } = this.props;

        const currentTab = this.getCurrentTab();
        const search = this.state.search.toUpperCase();
        const filteredList = search.length >= 3 ? list.filter(x => x.firstName.toUpperCase().indexOf(search) >= 0 || x.lastName.toUpperCase().indexOf(search) >= 0) : list;
        const sortedList = _.sortBy(filteredList, item => item.connectToDonorNextFollowUpDate);
        const canTransfer = this.props.user.roles.find(x => x.id == AuthRole.DonorConnectAccessAll) != null;

        const currentRegistration = list.find(x => x.id == this.state.registrationId);

        const allowMentorChange = this.props.user.roles.find(x => x.id == AuthRole.DonorConnectAccessAll) != null;

        const transferDonorName = currentRegistration != null ? currentRegistration.firstName + ' ' + currentRegistration.lastName : '';
        const transferDonorEmail = currentRegistration != null ? currentRegistration.email : '';
        const transferDonorBirthDate = currentRegistration != null ? currentRegistration.birthDate : '';
        const transferDonorCurrentCenterId = currentRegistration != null ? currentRegistration.centerId : 0;
        const transferDonorCurrentCenterAlias = currentRegistration != null ? currentRegistration.centerAlias : '';

        return (
            <>
                <div>
                    <DropdownButtonWrapper style={{ marginBottom: 10 }}>
                        <DropdownButton
                            id='m-1'
                            title={currentTab}
                        >
                            <MenuItem href='/donor-connect/unassigned' eventKey='UNASSIGNED'>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div>UNASSIGNED</div>
                                    <div>{counts.unassigned}</div>
                                </div>
                            </MenuItem>
                            <MenuItem href='/donor-connect/to-do' eventKey='TODO'>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div>TO-DO</div>
                                    <div>{counts.todo}</div>
                                </div>
                            </MenuItem>
                            <MenuItem href='/donor-connect/assigned-to-me' eventKey='MINE'>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div>ASSIGNED TO ME</div>
                                    <div>{counts.assignedToMe}</div>
                                </div>
                            </MenuItem>
                            <MenuItem href='/donor-connect/all' eventKey='ALL'>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div>ALL</div>
                                    <div>{counts.all}</div>
                                </div>
                            </MenuItem>
                        </DropdownButton>
                    </DropdownButtonWrapper>

                    {this.props.currentTab == donorConnectTabs.ALL && (
                        <>
                            <FormGroup>
                                <ControlLabel>Status</ControlLabel>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div style={{ width: '83%' }}>
                                        <FormControl
                                            componentClass='select'
                                            name='statusFilter'
                                            bsSize='sm'
                                            value={this.props.statusFilter}
                                            onChange={this.handleFilterChange}
                                        >
                                            <option value={-1}>- Any Status -</option>
                                            {statusList.map((item, index) =>
                                                <option key={`ctr-${index}`} value={item.id}>{item.description}</option>
                                            )}
                                        </FormControl>
                                    </div>
                                    <Button bsStyle='primary' bsSize='sm' onClick={() => this.props.onFilterSubmit(false)}>Search</Button>
                                </div>
                            </FormGroup>
                        </>
                    )}

                    <FormGroup>
                        <ControlLabel>Search</ControlLabel>
                        <FormControl
                            placeholder='Enter 3 or more characters to search by the name...'
                            value={this.state.search}
                            onChange={this.handleSearchChange}
                        />
                    </FormGroup>

                    {sortedList.length == 0 && (
                        <div>No registrations found...</div>
                    )}

                    <PanelGroup accordion activeKey={this.state.mobileActiveKey} onSelect={this.handlePanelItemSelect}>
                        {sortedList.map(item => {
                            const disableNextFollowUpDateSaveButton = moment(item.connectToDonorNextFollowUpDate, 'MM/DD/YYYY', true).isValid() == false;
                            const currentMilestone = milestones.find(x => x.milestone == item.connectToDonorMilestone);
                            const nextMilestone = milestones.find(x => x.milestone == item.connectToDonorNextMilestone);
                            const donated = this.props.statusList.find(s => s.id === item.connectToDonorStatusId).description.includes('Donated');
                            const donationDetailsSaved = this.props.savedDonationDetailIds.includes(item.id);
                            const donationDateInvalid = item.mentorDonationDate == '' || item.mentorDonationDate == null || moment(item.mentorDonationDate, 'MM/DD/YYYY', true).isAfter(moment(), 'day');
                            const donationTypeInvalid = item.mentorDonationTypeId == '' || item.mentorDonationTypeId == null || item.mentorDonationTypeId == 0 || item.mentorDonationTypeId == '0';
                            const donationCenterInvalid = !item.mentorDonationCenterId;
                            const disableDonationDetailsSaveButton = donationDateInvalid || donationTypeInvalid || donationCenterInvalid;

                            return (
                                <Panel key={'dc-' + item.id} eventKey={item.id}>
                                    <Panel.Heading>
                                        <Panel.Title componentClass='h3' toggle>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <div>{item.firstName} {item.lastName}</div>
                                                <div>{this.renderNextFollowupDate(item)}</div>
                                            </div>
                                        </Panel.Title>
                                    </Panel.Heading>
                                    <PanelBodyWrapper collapsible>
                                        {this.state.mobileActiveKey == item.id && (
                                            <>
                                                <FormGroup>
                                                    <ControlLabel>Entry Source</ControlLabel>
                                                    <div>{item.entrySource}</div>
                                                </FormGroup>

                                                <FormGroup>
                                                    <ControlLabel>Recipient Center</ControlLabel>
                                                    <div>{item.recipientCenterAlias}</div>
                                                </FormGroup>

                                                {item.preferredName != null ?
                                                    <> <FormGroup>
                                                        <ControlLabel>Preferred name/Chosen name</ControlLabel>
                                                        <div>{item.preferredName}</div>
                                                    </FormGroup> </>
                                                    :
                                                    <></>}

                                                <FormGroup>
                                                    <ControlLabel>Email</ControlLabel>
                                                    <div>{item.email}</div>
                                                </FormGroup>

                                                <FormGroup>
                                                    <ControlLabel>Mobile Number <span className='label label-default'>if available</span></ControlLabel>
                                                    <div>{item.mobileNumber}</div>
                                                </FormGroup>

                                                <FormGroup>
                                                    <ControlLabel>Phone Number(s)</ControlLabel>
                                                    {item.phoneNumber != '' ?
                                                        <>
                                                            <div>{item.phoneNumber}</div>
                                                            {item.phoneNumberSecondary != '' && (
                                                                <div>{item.phoneNumberSecondary}</div>
                                                            )}
                                                        </>
                                                        :
                                                        <div>--</div>
                                                    }
                                                </FormGroup>

                                                <FormGroup>
                                                    <ControlLabel>Location</ControlLabel>
                                                    <div>
                                                        {item.city != '' && item.state != '' ?
                                                            <div>{item.city}, {item.state}</div>
                                                            :
                                                            <div>--</div>
                                                        }
                                                    </div>
                                                </FormGroup>

                                                <FormGroup>
                                                    <ControlLabel>Selected Center</ControlLabel>
                                                    <div>
                                                        {item.centerAlias}&nbsp;
                                                        {canTransfer && (
                                                            <Button bsSize='xs' onClick={() => this.handleShowTransferDonor(item.id)}>Transfer Donor</Button>
                                                        )}
                                                    </div>
                                                </FormGroup>

                                                <FormGroup>
                                                    <ControlLabel>Preferred Donation Type</ControlLabel>
                                                    <div>
                                                        <PreferredDonationType
                                                            voucherEducationChoiceId={item.voucherEducationChoiceId}
                                                            donorSituationId={item.donorSituationId} />
                                                    </div>
                                                </FormGroup>

                                                <FormGroup>
                                                    <ControlLabel>Status</ControlLabel>
                                                    <div>
                                                        <FormControl
                                                            componentClass='select'
                                                            value={item.connectToDonorStatusId}
                                                            onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => this.props.onStatusChange(item.id, parseInt(e.currentTarget.value))}
                                                        >
                                                            {statusList.map(item =>
                                                                <option key={'st-' + item.id} value={item.id}>{item.description}</option>
                                                            )}
                                                        </FormControl>
                                                    </div>
                                                </FormGroup>

                                                {item.connectToDonorStatusId === 11 && (
                                                    <ConnectToDonorStatus
                                                        id={item.id}
                                                        gambitData={item.dashGambitData}
                                                        gambitType={GambitType.DonotIntakeOnHoldReason_ConnectToDonorStatus}
                                                        showControlLabel={true}
                                                        onTextChange={this.props.onHoldStatusReasonChange}
                                                    />
                                                )}

                                                {donated && (
                                                    <Well bsSize='sm' style={{ marginTop: 10 }}>
                                                        <FormGroup validationState={item.mentorDonationCenterId > 0 ? null : 'error'}>
                                                            <ControlLabel>Donation Center:</ControlLabel>
                                                            {donationDetailsSaved ? (
                                                                <div>
                                                                    {this.props.centerList.find(center => center.id == item.mentorDonationCenterId)?.alias || ''}
                                                                    {this.props.centerList.find(center => center.id == item.mentorDonationCenterId && !center.isMemberCenter) ? ' (non-member)' : ''}
                                                                </div>
                                                            ) : (
                                                                <FormControl
                                                                    componentClass='select'
                                                                    value={item.mentorDonationCenterId || 0}
                                                                    onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => this.props.onDonationCenterChange(item.id, e.currentTarget.value)}
                                                                >
                                                                    <option value={0}>Please Select</option>
                                                                    {this.props.centerList.map(center =>
                                                                        <option key={center.id} value={center.id}>{center.alias}{!center.isMemberCenter ? ' (non-member)' : ''}</option>
                                                                    )}
                                                                </FormControl>
                                                            )}
                                                        </FormGroup>
                                                        <FormGroup validationState={item.mentorDonationDate == '' || moment(item.mentorDonationDate, 'MM/DD/YYYY', true).isAfter(moment(), 'day') ? 'error' : null}>
                                                            <ControlLabel>Donation Date:</ControlLabel>
                                                            {donationDetailsSaved ? (
                                                                <div>{item.mentorDonationDate}</div>
                                                            ) : (
                                                                <>
                                                                    <FormControl
                                                                        type='date'
                                                                        max={moment().format('YYYY-MM-DD')}
                                                                        value={item.mentorDonationDate && moment(item.mentorDonationDate, 'MM/DD/YYYY', true).isValid()
                                                                            ? moment(item.mentorDonationDate, 'MM/DD/YYYY').format('YYYY-MM-DD')
                                                                            : ''}
                                                                        onFocus={(e: React.FocusEvent<FormControl & HTMLInputElement>) => (e.currentTarget as any).showPicker?.()}
                                                                        onClick={(e: React.MouseEvent<FormControl & HTMLInputElement>) => (e.currentTarget as any).showPicker?.()}
                                                                        onChange={(e: React.FormEvent<FormControl & HTMLInputElement>) =>
                                                                            this.handleDonationDateChange(
                                                                                item.id,
                                                                                e.currentTarget.value
                                                                                    ? moment(e.currentTarget.value, 'YYYY-MM-DD').format('MM/DD/YYYY')
                                                                                    : ''
                                                                            )}
                                                                    />
                                                                    {moment(item.mentorDonationDate, 'MM/DD/YYYY', true).isAfter(moment(), 'day') && (
                                                                        <Label bsStyle='danger'>Donation date cannot be in the future.</Label>
                                                                    )}
                                                                </>
                                                            )}
                                                        </FormGroup>

                                                        <FormGroup validationState={donationTypeInvalid ? 'error' : null}>
                                                            <ControlLabel>Donation Type:</ControlLabel>
                                                            {donationDetailsSaved ? (
                                                                <div>{this.props.closeLoopDonationTypes.find(typeItem => typeItem.id == item.mentorDonationTypeId)?.description || ''}</div>
                                                            ) : (
                                                                <FormControl
                                                                    componentClass='select'
                                                                    value={item.mentorDonationTypeId}
                                                                    onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => this.handleDonationTypeChange(item.id, e.currentTarget.value)}
                                                                >
                                                                    <option value=''>Please Select</option>
                                                                    {this.props.closeLoopDonationTypes.map(typeItem =>
                                                                        <option value={typeItem.id}>{typeItem.description}</option>
                                                                    )}
                                                                </FormControl>
                                                            )}
                                                        </FormGroup>

                                                        {!donationDetailsSaved && (
                                                            <Button bsStyle='primary' bsSize='sm' title='Save Donation Details' disabled={disableDonationDetailsSaveButton} onClick={() => this.handleDonationUpdateClick(item.id)}>
                                                                Save Donation Details
                                                            </Button>
                                                        )}
                                                    </Well>
                                                )}

                                                <FormGroup>
                                                    <ControlLabel>Assigned Mentor</ControlLabel>
                                                    <div>
                                                        {allowMentorChange ?
                                                            <FormControl
                                                                componentClass='select'
                                                                value={item.connectToDonorAssignedUserId}
                                                                onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => this.props.onAssignedCounselorChange(item.id, parseInt(e.currentTarget.value))}
                                                            >
                                                                <option value={0}>- Not Assigned -</option>
                                                                {userList.map(item =>
                                                                    <option key={'au-' + item.id} value={item.id}>{item.firstName} {item.lastName} ({item.activeCaseCount}/{item.donorConnectCaseLoad})</option>
                                                                )}
                                                            </FormControl>
                                                            :
                                                            <FormControl.Static style={{ border: '1px solid #ccc', borderRadius: 4, padding: '6px 12px', backgroundColor: '#eee' }}>
                                                                {item.connectToDonorAssigndUser != null ?
                                                                    <>{item.connectToDonorAssigndUser.firstName} {item.connectToDonorAssigndUser.lastName}</>
                                                                    :
                                                                    null
                                                                }
                                                            </FormControl.Static>
                                                        }
                                                    </div>
                                                </FormGroup>

                                                <FormGroup>
                                                    <ControlLabel>Next Follow-Up Date</ControlLabel>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <div style={{ marginRight: 5 }}>
                                                            <MaskedInput
                                                                mask='11/11/1111'
                                                                placeholder='mm/dd/yyyy'
                                                                className='form-control'
                                                                value={item.connectToDonorNextFollowUpDate}
                                                                onChange={(e: any) => this.props.onNextFollowUpDateChange(item.id, e.currentTarget.value)}
                                                            />
                                                        </div>

                                                        <div style={{ marginRight: 5 }}>
                                                            <Button bsStyle='primary' bsSize='xs' disabled={disableNextFollowUpDateSaveButton} title='Save specified date' onClick={() => this.props.onUpdateNextFollowupDate(item.id)}>
                                                                <Glyphicon glyph='ok' />
                                                            </Button>
                                                        </div>

                                                        <div>
                                                            <Button bsStyle='danger' bsSize='xs' disabled={disableNextFollowUpDateSaveButton} title='Remove specified date' onClick={() => this.props.onRemoveNextFollowUpDate(item.id)}>
                                                                <Glyphicon glyph='trash' />
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </FormGroup>

                                                <FormGroup>
                                                    <ControlLabel>Milestone</ControlLabel>
                                                    <div>
                                                        {nextMilestone.buttonLabel != '' ?
                                                            <>
                                                                <div style={{ marginBottom: 10 }}>{currentMilestone.text}</div>
                                                                <Button bsStyle='primary' style={{ whiteSpace: 'normal' }} onClick={() => this.handleNextMilestone(item.id, item.connectToDonorMilestoneCanProgress, item.connectToDonorNextMilestone)}>{nextMilestone.buttonLabel}</Button>
                                                            </>
                                                            :
                                                            <>{currentMilestone.text}</>
                                                        }
                                                    </div>
                                                </FormGroup>

                                                {currentMilestone.milestone >= ConnectToDonorMilestone.Contacted && (
                                                    <FormGroup>
                                                        <ControlLabel>Voucher Choice:</ControlLabel>
                                                        <FormControl
                                                            componentClass='select'
                                                            value={item.mentorEducationChoice}
                                                            onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => this.props.onMentorEducationChoiceChange(item.id, parseInt(e.currentTarget.value))}
                                                        >
                                                            {this.props.mentorEducationChoiceList.map(item =>
                                                                <option key={'vc-' + item.id} value={item.id}>{item.description}</option>
                                                            )}
                                                        </FormControl>
                                                    </FormGroup>
                                                )}

                                                <Log
                                                    data={item}
                                                    statusList={statusList}
                                                    actionList={actionList}
                                                    userList={userList}
                                                    container={this}
                                                    isMobile={true}
                                                    onSaveLogEntry={this.props.onSaveLogEntry}
                                                    onDeleteLogEntry={this.props.onDeleteLogEntry}
                                                />
                                            </>
                                        )}
                                    </PanelBodyWrapper>
                                </Panel>
                            );
                        })}
                    </PanelGroup>
                </div>

                <WorkupSurvey
                    show={this.state.showWorkupSurvey}
                    container={this}
                    onSubmit={this.handleWorkupSurveySubmit}
                    onCancel={() => this.setState({ showWorkupSurvey: false })}
                />

                <PreOpSurvey
                    show={this.state.showPreOpSurvey}
                    container={this}
                    onSubmit={this.handlePreOpSurveySubmit}
                    onCancel={() => this.setState({ showPreOpSurvey: false })}
                />

                <PostDonationSurvey
                    show={this.state.showPostDonationSurvey}
                    container={this}
                    onSubmit={this.handlePostDonationSurveySubmit}
                    onCancel={() => this.setState({ showPostDonationSurvey: false })}
                />

                <PostDonation30DaysSurvey
                    show={this.state.showPostDonation30DaysSurvey}
                    container={this}
                    onSubmit={this.handlePostDonation30DaysSurveySubmit}
                    onCancel={() => this.setState({ showPostDonation30DaysSurvey: false })}
                />

                <TransferDonor
                    show={this.state.showTransferDonor}
                    name={transferDonorName}
                    email={transferDonorEmail}
                    birthDate={transferDonorBirthDate}
                    currentCenterId={transferDonorCurrentCenterId}
                    currentCenterAlias={transferDonorCurrentCenterAlias}
                    centerList={this.props.centerList}
                    container={this}
                    onCheckRegistration={this.props.onFindForTransfer}
                    onRequestTransfer={this.handleRequestTransfer}
                    onCompleteTransfer={this.handleCompleteTransfer}
                    onCancel={this.handleCancelTransferDonor}
                />
            </>
        );
    }
}

export default MobileView;
